import React from 'react';
import PropTypes from 'prop-types';
import { colourMasterSemiLight } from 'Styles/colors.css';

const dimensions = {
  y: {
    width: 80,
    height: 15,
  },
  x: {
    width: 15,
    height: 80,
  },
};

const viewbox = {
  y: { viewBox: '0 0 80 15' },
  x: { viewBox: '0 0 15 80' },
};

const rotation = {
  y: '-90',
  x: '0',
};

const ResizeHandle = ({ colour, axis }) =>

  <svg
    {...viewbox[axis]}
    {...dimensions[axis]}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill={colour}
      transform={`rotate(${rotation[axis]} 7.5 7.5)`}
    >
      <rect
        width="15"
        height="80"
        rx="7.5"
      />
    </g>
  </svg>;

ResizeHandle.propTypes = {
  colour: PropTypes.string,
  axis: PropTypes.string,
};

ResizeHandle.defaultProps = {
  colour: colourMasterSemiLight,
  axis: 'x',
};

export default ResizeHandle;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/ResizableContainer/ResizeHandle.jsx